$(document).ready(function () {

    // __________ Header
    $('#header--drawer-btn').click(function(e){
        e.preventDefault();
        $(this).toggleClass('open');
        $('.section-header').toggleClass('menu-open');
        $('#menu-drawer').fadeToggle();
        $('body').toggleClass('overflow-hidden');
    });
    // __________ Header

    // __________  Media Overlay Video
    if($('.media-overlay-text').length > 0){
        $('body').on('click', '.media-overlay-video-btn', function () {
            var $section = $(this).closest('.media-overlay-text');
            var $video = $section.find('video')[0];

            $('.media-overlay-text video').each(function () {
                if (this !== $video) {
                    this.pause();
                    $(this).closest('.media-overlay-text').removeClass('video-played');
                }
            });

            if ($video.paused) {
                $video.play();
                $section.addClass('video-played');
            } else {
                $video.pause();
                $section.removeClass('video-played');
            }
        });
    }
    // __________  Media Overlay Video


    // __________  Image text Column Slider
    if($('.image-text-column').length > 0){
        var image_text_column = new Swiper('.image-text-column .image-text-column-slider' ,{
            slidesPerView: 'auto',
            spaceBetween: 16,
            mousewheel: {
                forceToAxis: true
            },
            pagination: {
                el: ".image-text-column .image-text-column-slider .swiper-pagination",
                type: "progressbar",
            }
        });
    }
    // __________  Image text Column Slider


    // __________  Product Main Media
    if($('#product__media-main-list').length > 0 && $(window).width() < 750){
        var product_main_media = new Swiper('#product__media-main-list' ,{
            slidesPerView: 1,
            spaceBetween: 0,
            mousewheel: {
                forceToAxis: true
            },
            pagination: {
                el: "#product__media-main-list .swiper-pagination",
                type: "progressbar",
            }
        });
    }

    if($('.product-collaps-row').length > 0){
        $('.product-collaps-row .product-collaps-row-head').on('click', function () {
            $(this).parent('.product-collaps-row').siblings('.product-collaps-row').removeClass('active').find('.product-collaps-row-content').slideUp();
            $(this).parent('.product-collaps-row').toggleClass('active');
            $(this).next('.product-collaps-row-content').slideToggle();
        });
    }
    // __________  Product Main Media
    
});